<template>
  <v-autocomplete
    :value="value"
    :items="deviceOperators"
    :multiple="true"
    chips
    small-chips
    deletable-chips
    item-text="name"
    item-value="id"
    :label="$trans('device-operator-monitor.device-operators')"
    @change="emitInput"
  />
</template>

<script>

export default {
  props: {
    value: {
      required: true,
      type: Array,
    },
    deviceOperators: {
      required: true,
      type: Array,
    },
  },
  methods: {
    /**
     * Emit input current state
     * @param {array} deviceOperatorsIds Array of device operators ids
     */
    emitInput(deviceOperatorsIds) {
      this.$emit('input', deviceOperatorsIds);
    },
  },
};
</script>
